import * as exceptions from '../exceptions';
import { strings } from '../util';
function clean(input) {
    return strings.cleanUnicode(input, ' -./,');
}
function buildMatch(fmt) {
    const pattern = fmt.replace(/([FBUP])\1*/g, m => {
        return `(\\d{${m.length}})`;
    });
    const matcher = new RegExp(`^${pattern}$`);
    return (value) => {
        var _a, _b, _c, _d;
        const m = matcher.exec(value);
        if (!m) {
            return { match: false };
        }
        return {
            match: true,
            f: (_a = m[1]) !== null && _a !== void 0 ? _a : '',
            b: (_b = m[2]) !== null && _b !== void 0 ? _b : '',
            u: (_c = m[3]) !== null && _c !== void 0 ? _c : '',
            p: (_d = m[4]) !== null && _d !== void 0 ? _d : '',
        };
    };
}
function buildMatcher(rfmt, cfmt) {
    return {
        region: buildMatch(rfmt),
        country: buildMatch(cfmt),
    };
}
const REGION_FORMATS = {
    'DE-BW': buildMatcher('FFBBBUUUUP', '28FF0BBBUUUUP'),
    'DE-BY': buildMatcher('FFFBBBUUUUP', '9FFF0BBBUUUUP'),
    'DE-BE': buildMatcher('FFBBBUUUUP', '11FF0BBBUUUUP'),
    'DE-BB': buildMatcher('0FFBBBUUUUP', '30FF0BBBUUUUP'),
    'DE-HB': buildMatcher('FFBBBUUUUP', '24FF0BBBUUUUP'),
    'DE-HH': buildMatcher('FFBBBUUUUP', '22FF0BBBUUUUP'),
    'DE-HE': buildMatcher('0FFBBBUUUUP', '26FF0BBBUUUUP'),
    'DE-MV': buildMatcher('0FFBBBUUUUP', '40FF0BBBUUUUP'),
    'DE-NI': buildMatcher('FFBBBUUUUP', '23FF0BBBUUUUP'),
    'DE-NW': buildMatcher('FFFBBBBUUUP', '5FFF0BBBBUUUP'),
    'DE-RP': buildMatcher('FFBBBUUUUP', '27FF0BBBUUUUP'),
    'DE-SL': buildMatcher('0FFBBBUUUUP', '10FF0BBBUUUUP'),
    'DE-SN': buildMatcher('2FFBBBUUUUP', '32FF0BBBUUUUP'),
    'DE-ST': buildMatcher('1FFBBBUUUUP', '31FF0BBBUUUUP'),
    'DE-SH': buildMatcher('FFBBBUUUUP', '21FF0BBBUUUUP'),
    'DE-TH': buildMatcher('1FFBBBUUUUP', '41FF0BBBUUUUP'),
};
function findMatch(value) {
    let result = null;
    Object.values(REGION_FORMATS).some(({ region, country }) => {
        const rResult = region(value);
        if (rResult.match) {
            result = rResult;
            return true;
        }
        const cResult = country(value);
        if (cResult.match) {
            result = cResult;
            return true;
        }
        return false;
    });
    return result;
}
const impl = {
    compact(input) {
        const [value, err] = clean(input);
        if (err) {
            throw err;
        }
        return value;
    },
    format(input) {
        const [value] = clean(input);
        const match = findMatch(input);
        if (!match || !match.match) {
            return value;
        }
        return `${match.f}/${match.b}/${match.u} ${match.p}`;
    },
    validate(input) {
        const [value, error] = clean(input);
        if (error) {
            return { isValid: false, error };
        }
        if (![10, 11, 13].includes(value.length)) {
            return { isValid: false, error: new exceptions.InvalidLength() };
        }
        if (!strings.isdigits(value)) {
            return { isValid: false, error: new exceptions.InvalidFormat() };
        }
        const front = value.split('').map(v => parseInt(v, 10));
        const check = front.pop();
        const product = front.reduce((acc, v) => {
            let sum = (v + acc) % 10;
            if (sum === 0) {
                sum = 10;
            }
            return (sum * 2) % 11;
        }, 10);
        let checksum = 11 - product;
        if (checksum === 10) {
            checksum = 0;
        }
        if (checksum !== check) {
            return { isValid: false, error: new exceptions.InvalidChecksum() };
        }
        return {
            isValid: true,
            compact: value,
            isIndividual: false,
            isCompany: true,
        };
    },
};
export const { validate, format, compact } = impl;
//# sourceMappingURL=data:application/json;base64,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